import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import api from '../services/api';

import { ModelOfAuthState, ModelOfUser } from './model';

const AuthContext = createContext<ModelOfAuthState>({} as ModelOfAuthState);

export const AuthProvider: React.FC = ({ children }) => {
    const [userLevel, setUserLevel] = useState<number | null>(null);
    const [userId, setUserId] = useState<string | null>(null);
    const [userLogin, setUserLogin] = useState<string>('');
    const [userAgencyId, setUserAgencyId] = useState('');
    const [userAgencyName, setUserAgencyName] = useState('');
    const [userAgencyUnitId, setUserAgencyUnitId] = useState('');
    const [userAgencyUnitName, setUserAgencyUnitName] = useState('');
    const [userAgencyData, setUserAgencyData] = useState<any[]>();
    const [signInFailed, setSingInFailed] = useState(false);
    const [selectedPeopleUnity, setSelectedPeopleUnity] = useState<{ ID?: string; NOME: string }>({ ID: '', NOME: '' });
    const [loading, setLoading] = useState(true);
    const [people, setPeople] = useState('');
    const [dialogDemand, setDialogDemand] = useState(false);
    const [demand, setDemand] = useState();
    const [authDemand, setAuthDemand] = useState(false);

    const history = useHistory();
    const toast: any = useRef();

    useEffect(() => {
        async function loadLocalStorage() {
            try {
                const storagedUserLevel = sessionStorage.getItem('@inforfrota:userLevel');
                const storagedUserId = sessionStorage.getItem('@inforfrota:userId');
                const storagedUserAgencyId = sessionStorage.getItem('@inforfrota:userAgencyId');
                const storagedUserAgencyName = sessionStorage.getItem('@inforfrota:userAgencyName');
                const storagedUserAgencyUnitId = sessionStorage.getItem('@inforfrota:userAgencyUnitId');
                const storagedUserAgencyUnitName = sessionStorage.getItem('@inforfrota:userAgencyUnitName');
                const storagedUserAgencyData = sessionStorage.getItem('@inforfrota:userAgencyData');
                const storagedUserLogin = sessionStorage.getItem('@inforfrota:userLogin');
                const storagedPeople = sessionStorage.getItem('@inforfrota:people');

                const storagedPeopleUnity = sessionStorage.getItem('@inforfrota:peopleUnity');

                if (storagedUserLevel) {
                    setUserLevel(parseInt(storagedUserLevel));
                }
                if (storagedUserId) {
                    setUserId(storagedUserId);
                }
                if (storagedUserAgencyId) {
                    setUserAgencyId(storagedUserAgencyId);
                }
                if (storagedUserAgencyName) {
                    setUserAgencyName(storagedUserAgencyName);
                }
                if (storagedUserAgencyUnitId) {
                    setUserAgencyUnitId(storagedUserAgencyUnitId);
                }
                if (storagedUserAgencyUnitName) {
                    setUserAgencyUnitName(storagedUserAgencyUnitName);
                }
                if (storagedUserAgencyData) {
                    setUserAgencyData([JSON.parse(storagedUserAgencyData || '{}')]);
                }
                if (storagedUserLogin) {
                    setUserLogin(storagedUserLogin);
                }

                if (storagedPeopleUnity) {
                    setSelectedPeopleUnity(JSON.parse(storagedPeopleUnity || '{}'));
                }
                if (storagedPeople) {
                    setPeople(storagedPeople);
                }

                setLoading(false);
            } catch (err) {
                console.log(err);
                setLoading(false);
            }
        }
        loadLocalStorage();
    }, []);

    const signIn = async ({ email, password }: ModelOfUser) => {
        setLoading(true);
        const loginData = { LOGIN: email, SENHA: password };
        api.post('login', loginData)
            .then(response => {
                const userAgencyObj = {
                    ORGAO: response.data[0].ORGAO,
                    NOME_ORGAO: response.data[0].NOME_ORGAO,
                    CNPJ_ORGAO: response.data[0].CNPJ_ORGAO,
                    BAIRRO_ORGAO: response.data[0].BAIRRO_ORGAO,
                    CEP_ORGAO: response.data[0].CEP_ORGAO,
                    CIDADE_ORGAO: response.data[0].CIDADE_ORGAO,
                    NOME_CIDADE_ORGAO: response.data[0].NOME_CIDADE_ORGAO,
                    ENDERECO_ORGAO: response.data[0].ENDERECO_ORGAO,
                    ORGAOUNIDADE: response.data[0].ORGAOUNIDADE,
                    NOME_ORGAOUNIDADE: response.data[0].NOME_ORGAOUNIDADE,
                };

                if (response.status === 200) {
                    setUserLevel(response.data[0].NIVEL);
                    console.log(userLevel);
                    switch (response.data[0].NIVEL) {
                        case 0:
                            setUserId(response.data[0].ID);
                            setUserAgencyId(response.data[0].ORGAO);
                            setUserAgencyName(response.data[0].NOME_ORGAO);
                            setUserAgencyUnitId(response.data[0].ORGAOUNIDADE);
                            setUserAgencyUnitName(response.data[0].NOME_ORGAOUNIDADE);
                            setUserAgencyData([userAgencyObj]);
                            setUserLogin(loginData.LOGIN);
                            setPeople(response.data[0].PESSOA);

                            sessionStorage.setItem('@inforfrota:userLevel', response.data[0].NIVEL);
                            sessionStorage.setItem('@inforfrota:userId', response.data[0].ID);
                            sessionStorage.setItem('@inforfrota:userAgencyId', response.data[0].ORGAO);
                            sessionStorage.setItem('@inforfrota:userAgencyName', response.data[0].NOME_ORGAO);
                            sessionStorage.setItem('@inforfrota:userAgencyUnitId', response.data[0].ORGAOUNIDADE);
                            sessionStorage.setItem(
                                '@inforfrota:userAgencyUnitName',
                                response.data[0].NOME_ORGAOUNIDADE,
                            );
                            sessionStorage.setItem('@inforfrota:people', response.data[0].PESSOA);
                            sessionStorage.setItem('@inforfrota:userAgencyData', JSON.stringify(userAgencyObj));
                            sessionStorage.setItem('@inforfrota:userLogin', loginData.LOGIN);

                            history.push('/dashboard');

                            setSingInFailed(false);
                            setLoading(false);
                            break;
                        case 1:
                            setSingInFailed(true);
                            setLoading(false);
                            toast.current.show({
                                severity: 'error',
                                summary: 'Falha no login',
                                detail: 'Usuário não autorizado!',
                                sticky: true,
                            });
                            break;
                        case 2:
                            setUserId(response.data[0].ID);
                            setUserAgencyId(response.data[0].ORGAO);
                            setUserAgencyName(response.data[0].NOME_ORGAO);
                            setUserAgencyUnitId(response.data[0].ORGAOUNIDADE);
                            setUserAgencyUnitName(response.data[0].NOME_ORGAOUNIDADE);
                            setUserAgencyData([userAgencyObj]);
                            setUserLogin(loginData.LOGIN);
                            setPeople(response.data[0].PESSOA);

                            sessionStorage.setItem('@inforfrota:userLevel', response.data[0].NIVEL);
                            sessionStorage.setItem('@inforfrota:userId', response.data[0].ID);
                            sessionStorage.setItem('@inforfrota:userAgencyId', response.data[0].ORGAO);
                            sessionStorage.setItem('@inforfrota:userAgencyName', response.data[0].NOME_ORGAO);
                            sessionStorage.setItem('@inforfrota:userAgencyUnitId', response.data[0].ORGAOUNIDADE);
                            sessionStorage.setItem('@inforfrota:people', response.data[0].PESSOA);

                            sessionStorage.setItem(
                                '@inforfrota:userAgencyUnitName',
                                response.data[0].NOME_ORGAOUNIDADE,
                            );
                            sessionStorage.setItem('@inforfrota:userAgencyData', JSON.stringify(userAgencyObj));
                            sessionStorage.setItem('@inforfrota:userLogin', loginData.LOGIN);

                            history.push('/dashboard');

                            setSingInFailed(false);
                            setLoading(false);
                            break;
                    }
                }
            })
            .catch(error => {
                if (!!error.response) {
                    console.log(error.response.status);
                    if (error.response.status === 404) {
                        console.log(error.response.status);
                        setSingInFailed(true);
                        setLoading(false);
                        toast.current.show({
                            severity: 'error',
                            summary: 'Usuário não encontrado!',
                            detail: 'Login ou senha incorretos.',
                            sticky: true,
                        });
                    }
                    if (error.response.status === 500) {
                        setSingInFailed(true);
                        setLoading(false);
                        toast.current.show({
                            severity: 'error',
                            summary: 'Falha no login!',
                            detail: 'Podem haver problemas com o servidor. Aguarde alguns minutos e tente novamente!',
                            sticky: true,
                        });
                    }
                }
                if (!error.response) {
                    setSingInFailed(true);
                    setLoading(false);
                    toast.current.show({
                        severity: 'error',
                        summary: 'Falha no login!',
                        detail: 'O servidor pode estar fora do ar. Aguarde alguns minutos e tente novamente!',
                        sticky: true,
                    });
                }
            });
    };

    async function signOut() {
        sessionStorage.clear();
        setUserAgencyId('');
        setUserAgencyName('');
        setUserAgencyUnitId('');
        setUserAgencyUnitName('');
        setUserId(null);
        setUserLogin('');
        history.push('/');
    }

    const createUnityPeople = (Unity: { ID?: string; NOME: string }) => {
        setSelectedPeopleUnity(Unity);
        sessionStorage.setItem('@inforfrota:peopleUnity', JSON.stringify(Unity));
    };

    const listUnityPeople = (Unity: { ID?: string; NOME: string }) => {
        setSelectedPeopleUnity(Unity);
        sessionStorage.setItem('@inforfrota:peopleUnity', JSON.stringify(Unity));
    };

    return (
        <AuthContext.Provider
            value={{
                signInFailed,
                signed: Boolean(userId),
                userLevel,
                userId,
                userLogin,
                userAgencyId,
                userAgencyName,
                userAgencyUnitId,
                userAgencyUnitName,
                userAgencyData,
                selectedPeopleUnity,
                signIn,
                signOut,
                createUnityPeople,
                listUnityPeople,
                loading,
                toast,
                people,
                dialogDemand,
                setDialogDemand,
                demand,
                setDemand,
                authDemand,
                setAuthDemand,
            }}>
            {children}
        </AuthContext.Provider>
    );
};

function useAuth() {
    const context = useContext(AuthContext);

    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider.');
    }

    return context;
}

export { AuthContext, useAuth };
